import styled from "styled-components";

export const StyledContainerButton = styled.div<{ $bgColor: string }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 8px;
  background-color: ${(props) => props.$bgColor};
  text-transform: uppercase;
  pointer-events: none;
  user-select: none;
`;
